import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const DartsIcon = observer('DartsIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='dartsMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='m12.24 10.67.813.71c.182.154.112.513-.162.788l-.182.181 1.872 1.852a.317.317 0 0 1-.448.447l-1.864-1.86-.182.181c-.264.264-.618.334-.777.152l-.71-.812zM2.79 3.313 2.775 3.3l.448-.452.017.017.528-1.465 1.81 2.17-.084 1.548.572.572a.45.45 0 0 1 .492.001h-.002l5.049 4.422-1.561 1.56-4.417-5.045a.44.44 0 0 1 0-.492v.002l-.573-.572-1.548.084-2.172-1.81z'
                />
            </mask>
            <g mask='url(#dartsMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
